<template>
    <div class="selected-items-sum-label">{{ displayedSelectedItemsNumber }}</div>
</template>

<script setup lang="ts">
    import { translations } from "@/shared/localization/translations";
    import { computed } from "vue";

    // define properties
    const props = defineProps<{
        count: number;
    }>();

    // define computed
    const displayedSelectedItemsNumber = computed(() =>
        translations.order.itemsSelected.replace("{0}", (props.count ?? 0) + "")
    );
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .selected-items-sum-label {
        text-align: center;
        font-size: 14px;
        color: colors.$fontColor;
        line-height: 38px;
        height: 38px;
        letter-spacing: 0.3px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
